import React, { useEffect, useRef } from "react";
import { FaArrowDown } from "react-icons/fa";
import Avatar from "../assets/avatar.JPG";
import { init } from "ityped";
import { socialDt } from "./data";

const Hero = () => {
  const textRef = useRef();

  useEffect(() => {
    init(textRef.current, {
      backDelay: 1500,
      backSpeed: 60,
      showCursor: true,
      strings: ["Frontend", "Backend", "FullStack"],
    });
  }, []);

  window.addEventListener("scroll", function () {
    const downArrow = this.document.querySelector(".down-arrow");

    if (this.scrollY >= 2) downArrow.classList.add("hide-down-arrow");
    else downArrow.classList.remove("hide-down-arrow");
  });
  return (
    <section className="min-h-screen flex flex-col justify-start items-center pt-20 text-center">
      <h2 className="text-5xl text-rose-600 font-medium uppercase">
        Anup Poudel
      </h2>
      <h3 className="py-3 text-2xl">
        <span ref={textRef}></span> Developer
      </h3>
      <p className="max-w-xl font-light text-gray-400">
        Hello, <span className="animate-pulse text-4xl">👋 </span> I design and
        develop services for customers of all sizes, specializing in creating
        stylish, modern websites, web services and online stores.
      </p>
      <div className="flex py-8 justify-evenly lg:py-16 text-3xl w-full md:w1/3">
        {socialDt.map((social) => {
          return (
            <a
              href={social.link}
              key={social.id}
              target="_blank"
              rel="noopener noreferrer"
              className={`cursor-pointer duration-300 hover:text-rotate-600 hover:text-rose-200`}
            >
              {social.icon}
            </a>
          );
        })}
      </div>
      <div>
        <img
          src={Avatar}
          alt="avatar"
          className="w-60 h-60 md:w-72 md:h-72 object-cover object-top rounded-xl pt-5"
        />
      </div>
      <div className="mt-10 down-arrow">
        <FaArrowDown className="text-gray-400 text-2xl mt-10 animate-bounce cursor-pointer" />
      </div>
    </section>
  );
};

export default Hero;
